module.exports = {
    pcaa: require('area-data-vue/area-vue')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/area-data-vue/data.js
// module id = 46
// module chunks = 0